import {
  MLTaskStatus,
  MLTaskType,
  PaginatedMLTasksAdmin,
  PaginatedRecordingsAdmin,
  RecordingAdmin,
  RecordingAdminDetail,
  RecordingStatus,
} from '@/shared/types/Admin';

import { PLATFORM_API_URL } from '../constants';
import { RecordingRetryResponse } from '../recording/types';
import { del, get, post } from '../requestMethods';

const URL = `${PLATFORM_API_URL}/api/recording/v1/admin`;

export type GetRecordingsAdminParams = {
  date_from?: string;
  date_to?: string;
  limit?: number;
  offset?: number;
  search?: string;
  status?: RecordingStatus;
};

export type GetMLTasksAdminParams = {
  date_from?: string;
  date_to?: string;
  email?: string;
  limit?: number;
  offset?: number;
  status?: MLTaskStatus;
  task_type?: MLTaskType;
};

export type GetRecordingsCSVParams = {
  date_from?: string;
  date_to?: string;
  search?: string;
  status?: RecordingStatus;
};

export type GetMLTasksCSVParams = {
  date_from?: string;
  date_to?: string;
  email?: string;
  status?: MLTaskStatus;
  task_type?: MLTaskType;
};

const buildQueryString = (params: Record<string, number | string | undefined>): string => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== '') {
      searchParams.append(key, String(value));
    }
  });
  const query = searchParams.toString();
  return query ? `?${query}` : '';
};

export const RECORDING_ADMIN_API = {
  retryRecordingAdmin: (id: string) => post<RecordingRetryResponse>(`${URL}/recordings/${id}/retry`),
  deleteRecordingAdmin: (id: string) => del<void>(`${URL}/recordings/${id}`),

  getMLTasksAdmin: (params: GetMLTasksAdminParams) =>
    get<PaginatedMLTasksAdmin>(`${URL}/ml-tasks${buildQueryString(params)}`),

  getMLTasksCSVAdmin: (params: GetMLTasksCSVParams) => get<Blob>(`${URL}/ml-tasks/csv${buildQueryString(params)}`),

  getRecordingAdmin: (id: string) => get<RecordingAdmin>(`${URL}/recordings/${id}`),

  getRecordingAdminDetail: (id: string) => get<RecordingAdminDetail>(`${URL}/recordings/${id}/detail`),

  getRecordingsAdmin: (params: GetRecordingsAdminParams) =>
    get<PaginatedRecordingsAdmin>(`${URL}/recordings${buildQueryString(params)}`),

  getRecordingsAdminBySearch: (search: string, limit = 100) =>
    get<RecordingAdmin[]>(`${URL}/recordings/by-email?search=${encodeURIComponent(search)}&limit=${limit}`),

  getRecordingsCSVAdmin: (params: GetRecordingsCSVParams) =>
    get<Blob>(`${URL}/recordings/csv${buildQueryString(params)}`),
};
